// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28lzk","colMin":"styles_colMin__1lep4"};